import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const Forms2 = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <g>
      <g>
        <path
          d="M19,2H5C3.9,2,3,2.9,3,4v1v1v15h1v-1v-1V6h16v13v1v1h1V6V5V4C21,2.9,20.1,2,19,2z M20,5H4V4c0-0.6,0.4-1,1-1h14
				c0.6,0,1,0.4,1,1V5z"
        />
      </g>
      <g>
        <rect x="6" y="8" width="12" height="2" />
      </g>
      <g>
        <rect x="6" y="12" width="12" height="2" />
      </g>
      <g>
        <rect x="6" y="16" width="6" height="2" />
      </g>
    </g>
  </SvgIcon>
);

export default Forms2;
